module.exports = __webpack_public_path__ + "static/media/404-page-not-found-en.d02ec30f.png";